// @ts-nocheck


import React, { Component } from 'react';
import { navigate } from '../../../lib/routerAdapter';
import styled from 'styled-components';
import moment from 'moment';


import Button from 'antd/lib/button';
import notification from 'antd/lib/notification';
import { DatePicker, RangePicker } from '../../../components/ant/DatePicker';


import { formatDateTimeToISOString, goBack } from '../../../lib/helpers';
import { platonApi } from './../../../lib/api';

import { Selects, Form } from './../../../components';
import { Panel, Section } from './../../../components/layout';
import Grid, { GridItem } from './../../../components/layout/Grid';
import Header from './../../../components/layout/Header';
import Breadcrumbs, { Crumb } from './../../../components/layout/Breadcrumbs';
import { notificationLoading } from '../../../components/Notifications';
import CancelButton from '../../../components/CancelButton';
import { InputNumber } from '../../../components/inputs';

const { VehicleSelect } = Selects;

const Content = styled.div.withConfig({ displayName: "Form__Content", componentId: "sc-1mrm26j-0" })(["padding:16px;"]);


const StyledPanel = styled(Panel).withConfig({ displayName: "Form__StyledPanel", componentId: "sc-1mrm26j-1" })(["padding-top:0;"]);


const Footer = styled(Section).withConfig({ displayName: "Form__Footer", componentId: "sc-1mrm26j-2" })(["padding:16px;display:flex;justify-content:space-between;align-items:center;"]);













const InnerForm = ({
  onSubmit,
  onCancel,
  platon,
  showVehicleSelect
}) =>
<Form initialValues={platon} onSubmit={onSubmit}>
    {(FormField, formikProps) => {
    const {
      handleSubmit,
      handleBlur,
      setFieldValue,
      dirty,
      values
    } = formikProps;
    return (
      <form onSubmit={handleSubmit}>
          <Section>
            <Content>
              <Grid gutter="16px">
                {showVehicleSelect &&
              <GridItem>
                    <FormField label="ТС" required name="vehicleId">
                      {({ name, value }) =>
                  <VehicleSelect
                    name={name}
                    value={value}
                    onBlur={() => handleBlur({ target: { name } })}
                    onChange={(value) =>
                    setFieldValue(name, value)
                    }
                    data-cy="vehicleSelect" />

                  }
                    </FormField>
                  </GridItem>
              }
                <GridItem>
                  <FormField
                  fast
                  required
                  label="Дата оказания услуги"
                  name="maintenanceDate">

                    {({ value, name }) =>
                  <DatePicker
                    format="DD.MM.YYYY"
                    value={value ? moment(value) : null}
                    onChange={(value, dateString) => {
                      setFieldValue(
                        name,
                        formatDateTimeToISOString(value, dateString)
                      );
                    }} />

                  }
                  </FormField>
                </GridItem>
                <GridItem>
                  <FormField name="startDate" required label="Период оказания">
                    {({ name, value }) =>
                  <RangePicker
                    format="DD.MM.YYYY"
                    placeholder={['Начало', 'Конец']}
                    value={[
                    values.startDate ?
                    moment.utc(values.startDate) :
                    null,
                    values.endDate ? moment.utc(values.endDate) : null]
                    }
                    onChange={(value, dateString) => {
                      const [startDate, endDate] = value;
                      const [startDateString, endDateString] = dateString;
                      setFieldValue(
                        'startDate',
                        formatDateTimeToISOString(
                          startDate,
                          startDateString
                        )
                      );
                      setFieldValue(
                        'endDate',
                        formatDateTimeToISOString(endDate, endDateString)
                      );
                    }} />

                  }
                  </FormField>
                </GridItem>
                <GridItem>
                  <FormField
                  fast
                  label="Сумма оплаты, руб."
                  name="paymentAmount">

                    {({ name, value }) =>
                  <InputNumber
                    name={name}
                    value={value}
                    onChange={(value) => setFieldValue(name, value)} />

                  }
                  </FormField>
                </GridItem>
              </Grid>
            </Content>
          </Section>
          <Footer>
            <Button type="primary" htmlType="submit" data-cy="save">
              Сохранить
            </Button>
            <CancelButton dirty={dirty} onClick={onCancel}>
              Отменить
            </CancelButton>
          </Footer>
        </form>);

  }}
  </Form>;











class PlatonForm extends Component {
  state = {};

  async componentDidMount() {
    try {
      const platonId = parseInt(this.props.platonId, 10);
      const vehicleId = parseInt(this.props.vehicleId, 10);

      if (platonId) {
        const platon = await platonApi.fetchPlaton(platonId);
        this.setState({
          platon
        });
      } else if (vehicleId) {
        this.setState({
          platon: {
            vehicleId
          }
        });
      } else {
        this.setState({
          platon: {}
        });
      }
    } catch (error) {
      notification.error({
        message: 'Ошибка',
        description: error.message
      });
      this.redirect();
    }
  }

  redirect = (id = this.props.platonId) => {
    if (this.props.vehicleId) {
      navigate(`/vehicles/${this.props.vehicleId}/maintenance/platons`);
    } else {
      goBack(`/services/platons/${id || ''}`);
    }
  };

  onSubmit = async (platon) => {
    try {
      notificationLoading({
        message: 'Сохранение данных...',
        key: 'saving'
      });
      const platonId = parseInt(this.props.platonId, 10);
      if (platonId) {
        await platonApi.updatePlaton(platon);
        notification.success({
          message: 'Успешное обновление',
          description: 'Данные были успешно обновлены'
        });
        this.redirect(platonId);
      } else {
        const added = await platonApi.addPlaton(platon);

        notification.success({
          message: 'Успешное добавление',
          description: `Платон успешно добавлен`
        });

        this.redirect(added.id);
      }
    } catch (error) {
      notification.error({
        message: 'Ошибка',
        description: error.message
      });
    } finally {
      notification.destroy('saving');
    }
  };

  render() {
    const platonId = parseInt(this.props.platonId, 10);
    const vehicleId = parseInt(this.props.vehicleId, 10);
    const { platon } = this.state;
    return (
      <>
        <Header
          left={
          <Breadcrumbs>
              <Crumb to="/">Главная</Crumb>
              {vehicleId > 0 ?
            <Crumb to={`/vehicles/${vehicleId}`}>ТС</Crumb> :

            <Crumb to={'/services/platons'}>Список актов "Платон"</Crumb>
            }
              {platonId ?
            <Crumb>Редактирование акта</Crumb> :

            <Crumb>Новый акт</Crumb>
            }
            </Breadcrumbs>
          } />

        <StyledPanel>
          <h1>
            {platonId ? `Акт "Платон" №${platonId}` : 'Новый акт "Платон"'}
          </h1>
        </StyledPanel>
        <InnerForm
          platon={{
            paymentAmount: 0,
            ...platon
          }}
          onSubmit={this.onSubmit}
          onCancel={() => this.redirect(platon.id || platonId)}
          showVehicleSelect={!this.props.vehicleId} />

      </>);

  }
}

export default PlatonForm;
